{
    "press": {
        "title": "Sala de prensa",
        "contact": "Para oportunidades de prensa, envía un e-mail a <a class=\"{variant}\" href=\"mailto:{email}\">{email}</a>",
        "material": "Materiales de prensa",
        "read_article": "Leer artículo",
        "open_link": "Abrir vínculo",
        "download": "Descargar",
        "load_more_articles": "Cargar más artículos",
        "load_more_materials": "Cargar más material",
        "no_articles": "Estamos preparando más contenido. ¡Vuelve pronto!",
        "no_materials": "Estamos preparando más contenido. ¡Vuelve pronto!",
        "article_not_found": "Este contenido no está disponible en español",
        "article_not_found_description": "<a class=\"{variant}\" href=\"{link}\">Haz click aquí</a> para volver a nuestra página de Prensa en inglés, o envíanos un correo a <a class=\"{emailVariant}\" href=\"mailto:{email}\">{email}</a>"
    }
}